<template>
  <div>
    <div style="margin-bottom: 40px; font-size: 40px;color: rgb(77 143 230);text-align: center;font-weight: 700;text-shadow: 0 0 black;">
      Supernet Tour CDB
    </div>
    <a-spin style="padding-top: 20px;" :spinning="loading" tip="Loading..., Please Wait.">
      <div class="spin-content"></div>
    </a-spin>
    <div style="max-width: 400px; margin: 0 auto;">
      <a-alert
        type="error"
        show-icon
        v-if="errorMessage"
      >
        <span slot="message" style="font-size:1.1rem;font-weight:700;">Login Error</span>
        <span slot="description" style="font-size:1.2rem;">{{ errorMessage }}</span>
      </a-alert>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { portalTokenLogin } from '@/api/login'

export default {
  components: {
  },
  data () {
    return {
      loading: true,
      errorMessage: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions(['SetAccessToken']),
    async loadData () {
      this.loading = true
      this.errorMessage = null
      const adminPortalToken = this.$route.query.portalToken
      if (!adminPortalToken || adminPortalToken.trim().length === 0) {
        this.$router.replace('/404')
      }
      try {
        const res = await portalTokenLogin(adminPortalToken)
        // 登录失败
        if (!res.success) {
          this.errorMessage = res.errorMessage
          this.loading = false
          return
        }
        // 登录成功
        const newToken = res.data.accessToken
        this.SetAccessToken(newToken)
        this.$router.push({ name: 'dashboard' })
        this.loading = false
      } catch (e) {
        console.log('catch error', e)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-spin-text {
  font-size: 1.2rem;
  padding-top: 12px;
  color:#222;
}
::v-deep .ant-spin-nested-loading {
  padding-top: 10px;
}
</style>
